var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.loadingColor },
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c("multiselect", {
                      attrs: {
                        options: _vm.records,
                        multiple: false,
                        label: "name",
                        "track-by": "name",
                        placeholder: "Выберите пользователя",
                        "select-label": "Выбрать",
                        "deselect-label": "Убрать",
                      },
                      on: { input: _vm.loadHistory },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "singleLabel",
                            fn: function (props) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.option.name) +
                                    "\n              ("
                                ),
                                _vm._l(props.option.roles, function (role) {
                                  return _c("span", [
                                    _vm._v(_vm._s(role.name_title)),
                                  ])
                                }),
                                _vm._v(")\n            "),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        440406029
                      ),
                      model: {
                        value: _vm.selected_user,
                        callback: function ($$v) {
                          _vm.selected_user = $$v
                        },
                        expression: "selected_user",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-3" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.message,
                            expression: "message",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { placeholder: "Сообщение", rows: "5" },
                        domProps: { value: _vm.message },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.message = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-right mt-2" },
                      [
                        _c("LoadingButton", {
                          attrs: {
                            title: "Отправить",
                            className: "btn btn-success mb-1",
                            onClick: _vm.sendMessage,
                            loading: _vm.btnLoading,
                            color: "white",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-8" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _vm._v("\n              История\n            "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("pulse-loader", {
                          staticClass: "text-center",
                          attrs: {
                            loading: _vm.historyLoading,
                            color: _vm.loadingColor,
                          },
                        }),
                        _vm._v(" "),
                        !_vm.historyLoading &&
                        _vm.selected_user &&
                        _vm.selected_user.id
                          ? _c("div", [
                              _c("div", [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table table-sm table-hover",
                                  },
                                  [
                                    _c(
                                      "tbody",
                                      [
                                        _vm._l(
                                          _vm.history[_vm.selected_user.id]
                                            .dialogs,
                                          function (dialog) {
                                            return [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { attrs: { width: "30px" } },
                                                  [
                                                    _c("i", {
                                                      class: [
                                                        "icon-fa",
                                                        {
                                                          "icon-fa-arrow-circle-right green":
                                                            dialog.system_send,
                                                          "icon-fa-arrow-circle-left blue":
                                                            !dialog.system_send,
                                                        },
                                                      ],
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _c("strong", [
                                                    _vm._v("Диалог:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        dialog.text &&
                                                          (dialog.text.text ||
                                                            dialog.text.action)
                                                      ) +
                                                      " (" +
                                                      _vm._s(dialog.id) +
                                                      ")"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { width: "90px" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.moment(
                                                          dialog.created_at,
                                                          "HH:mm DD.MM"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { width: "30px" } },
                                                  [
                                                    !dialog.is_active
                                                      ? _c("i", {
                                                          staticClass:
                                                            "icon-fa icon-fa-remove gray",
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(
                                                dialog.answers,
                                                function (answer) {
                                                  return _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          width: "30px",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          class: [
                                                            "icon-fa",
                                                            {
                                                              "icon-fa-arrow-circle-right green":
                                                                answer.system_send,
                                                              "icon-fa-arrow-circle-left blue":
                                                                !answer.system_send,
                                                            },
                                                          ],
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _c("div", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            answer.text &&
                                                              (answer.text
                                                                .text ||
                                                                answer.text
                                                                  .action)
                                                          ),
                                                        },
                                                      }),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          width: "90px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.moment(
                                                              answer.created_at,
                                                              "HH:mm DD.MM"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          width: "30px",
                                                        },
                                                      },
                                                      [
                                                        !answer.is_active
                                                          ? _c("i", {
                                                              staticClass:
                                                                "icon-fa icon-fa-remove gray",
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ])
                                                }
                                              ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }